 import {
   Collapsible,
   CollapsibleContent,
   CollapsibleTrigger,
 } from "@/components/ui/collapsible";
 import { ChevronDown, DollarSign } from "lucide-react";
 import { formatCurrency, formatPercent } from "@/lib/pricing-calculations";
 import { useState } from "react";
 import { cn } from "@/lib/utils";
 
 interface CostBreakdownCardProps {
   ingredientCost: number;
   cmvValue: number;
   cmvPercentage: number;
 }
 
 export function CostBreakdownCard({
   ingredientCost,
   cmvValue,
   cmvPercentage,
 }: CostBreakdownCardProps) {
   const [isOpen, setIsOpen] = useState(true);
 
   return (
     <Collapsible open={isOpen} onOpenChange={setIsOpen}>
       <CollapsibleTrigger className="flex items-center justify-between w-full p-3 bg-muted/50 rounded-lg hover:bg-muted/70 transition-colors">
         <div className="flex items-center gap-2">
           <DollarSign className="h-4 w-4 text-muted-foreground" />
           <span className="font-medium text-sm">Custo do Prato</span>
         </div>
         <ChevronDown 
           className={cn(
             "h-4 w-4 text-muted-foreground transition-transform",
             isOpen && "rotate-180"
           )} 
         />
       </CollapsibleTrigger>
       <CollapsibleContent>
         <div className="grid grid-cols-3 gap-3 p-3 pt-2">
           <div className="text-center p-3 bg-background rounded-lg border">
             <p className="text-[10px] text-muted-foreground uppercase tracking-wide">Custo Insumos</p>
             <p className="font-bold text-sm text-foreground mt-1">
               {formatCurrency(ingredientCost)}
             </p>
           </div>
           <div className="text-center p-3 bg-background rounded-lg border">
             <p className="text-[10px] text-muted-foreground uppercase tracking-wide">CMV (R$)</p>
             <p className="font-bold text-sm text-destructive mt-1">
               {formatCurrency(cmvValue)}
             </p>
           </div>
           <div className="text-center p-3 bg-background rounded-lg border">
             <p className="text-[10px] text-muted-foreground uppercase tracking-wide">CMV (%)</p>
             <p className="font-bold text-sm text-destructive mt-1">
               {formatPercent(cmvPercentage)}
             </p>
           </div>
         </div>
       </CollapsibleContent>
     </Collapsible>
   );
 }